module.exports = __webpack_public_path__ + "static/36-b70535d1cdf614c2130a87ab2e5b2688.jpg";